module.exports = __webpack_public_path__ + "img/rented-equipment.609272e9.svg";